const typographyformCreateUser = {
  text: 'Cadastro de Novo Usuário'
};

export default typographyformCreateUser;
